import React from 'react'
import { connect } from 'react-redux'
import { Link, Routes, Route } from 'react-router-dom'

import { handleSignOut } from '../../actions/auth'
import { routes, nestedRoutePath } from '../../constants/routes'

import TripsIndex from './trips/index'
import LeadsIndex from './leads/index'
import AgentsIndex from './agents/index'
import BookingsIndex from './bookings/index'
import CommissionsIndex from './commissions/index'
import AppDashboard from './agents/dashboard'

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
}

const AppIndex = ({ dispatch, user }) => {
    return (
        <>
            <div className="main-nav">
                <div className="logo-title">
                    <span>Luna Moons Lead Platform</span>
                </div>
                <div className="links">
                    <div className="sections">
                        { user._computed?.roleLevel === 1000 &&
                            <Link to={routes.adminIndex}>Admin</Link>
                        }
                        <Link to={routes.leadsIndex}>Leads</Link>
                        <Link to={routes.bookingsIndex}>Bookings</Link>
                        {/* <Link to={routes.agentsIndex}>Agents</Link> */}
                        {/* <Link to={routes.tripsIndex}>Trips</Link> */}
                        <Link to={routes.commissionsIndex}>Commissions</Link>
                    </div>
                    <div className="account">
                        <span className="clickable" onClick={() => dispatch(handleSignOut())}>Sign Out</span>
                    </div>
                </div>
            </div>
            <div id="route-content">
                <Routes>
                    <Route path={nestedRoutePath(routes.appIndex, routes.tripsIndex, true)} element={<TripsIndex />} />
                    <Route path={nestedRoutePath(routes.appIndex, routes.leadsIndex, true)} element={<LeadsIndex />} />
                    <Route path={nestedRoutePath(routes.appIndex, routes.agentsIndex, true)} element={<AgentsIndex />} />
                    <Route path={nestedRoutePath(routes.appIndex, routes.bookingsIndex, true)} element={<BookingsIndex />} />
                    <Route path={nestedRoutePath(routes.appIndex, routes.commissionsIndex, true)} element={<CommissionsIndex />} />
                    <Route path="*" element={<AppDashboard />} />
                </Routes>
            </div>
        </>
    )
}

export default connect(mapStateToProps)(AppIndex)
